import { ref } from 'vue';

// Mobile-browser navigation drawer state. The sidebar collapses off-canvas on
// narrow viewports (when NOT in the native app — there the native shell owns
// navigation); a hamburger in the canvas topbar toggles it. Module-level so the
// topbar trigger and the layout drawer share one source of truth.
const isOpen = ref(false);

// Tapping a parent nav item that has children navigates to reveal those children
// (the active sub-nav is route-driven) — but we want the drawer to stay open so
// the user can pick a child. This one-shot flag tells the route-change watcher to
// skip its usual auto-close for that one navigation. Every sidebar nav handler
// sets it explicitly right before navigating, so it never goes stale across taps.
let skipNextAutoClose = false;

export function useMobileNav() {
    return {
        isOpen,
        open: () => (isOpen.value = true),
        close: () => (isOpen.value = false),
        toggle: () => (isOpen.value = !isOpen.value),
        // Declare the intent for the navigation that's about to happen.
        setSkipNextAutoClose: (skip: boolean) => (skipNextAutoClose = skip),
        // Called by the route-change watcher: close the drawer unless a keep-open
        // navigation asked us to skip (consumed once).
        autoClose: () => {
            if (skipNextAutoClose) {
                skipNextAutoClose = false;
                return;
            }
            isOpen.value = false;
        }
    };
}
